module.exports = __webpack_public_path__ + "assets/img/Ilkley-Cricket-Club.3afc102a.png";